import Reveal from './Reveal';

const audiences = [
  { num: '01', title: 'Individuals & Families', copy: 'Returns and planning built around your life — investments, real estate, retirement, trusts, and estates — and everything in between.' },
  { num: '02', title: 'Healthcare Professionals', copy: 'Physicians, dentists, veterinarians, and group practices face unique entity, compensation, and retirement questions — and from associateship to ownership, we guide them through practice acquisition, equipment planning, and growth. We answer those questions year-round.' },
  { num: '03', title: 'Professional Service Firms', copy: 'Attorneys, consultants, architects, and engineers trust us with books, taxes, and the numbers behind the business.' },
];

export default function Audiences() {
  return (
    <section id="audiences" data-testid="audiences-section" className="bg-navy py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            <span className="eyebrow-rule" />
            Who we serve
          </p>
          <h2 data-testid="audiences-heading" className="font-serif tracking-tight text-cream text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.08]">
            Advisory shaped to <span className="italic text-gold-light">your profession.</span>
          </h2>
        </Reveal>

        <div className="mt-20">
          {audiences.map((a, i) => (
            <Reveal key={a.num} delay={i * 0.08}>
              <div
                data-testid={`audience-row-${a.num}`}
                className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline py-10 border-t border-cream/15 last:border-b transition-colors duration-500 hover:bg-navy-light/60 md:px-6 -mx-0 md:-mx-6"
              >
                <span className="md:col-span-1 font-serif italic text-gold text-lg">{a.num}</span>
                <h3 className="md:col-span-4 font-serif text-cream text-2xl lg:text-3xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">
                  {a.title}
                </h3>
                <p className="md:col-span-7 text-cream/60 font-light leading-relaxed text-sm lg:text-base max-w-xl">
                  {a.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
